import { useEffect, useRef } from "react";

/**
 * Extrait vidéo joué par-dessus la vignette pendant le survol de la carte.
 * La vidéo n'est chargée qu'au moment du survol (aucun coût réseau sur une liste).
 */
export const ApercuVideoSurvol = ({ annonceId, actif = false, testid }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (actif) ref.current?.play().catch(() => {});
  }, [actif]);

  if (!actif) return null;
  const src = `${process.env.REACT_APP_BACKEND_URL}/api/annonces/${annonceId}/apercu-video`;
  return (
    <video
      ref={ref}
      src={src}
      muted
      loop
      playsInline
      preload="auto"
      data-testid={testid}
      className="pointer-events-none absolute inset-0 z-[6] h-full w-full object-cover"
    />
  );
};

export default ApercuVideoSurvol;
